export const DEVICE_TYPES = [
  'smoke_detector',
  'heat_detector',
  'pull_station',
  'horn_strobe',
  'sprinkler_head',
  'fire_extinguisher',
  'control_panel',
  'flow_switch',
  'tamper_switch',
  'backflow_preventer',
  'suppression_system',
  'fire_door',
  'damper',
  'emergency_light',
  'exit_sign',
  'other'
] as const;

export type DeviceType = (typeof DEVICE_TYPES)[number];

export const DEVICE_PLACEMENTS = ['in_suite', 'common_area', 'unspecified'] as const;
export type DevicePlacement = (typeof DEVICE_PLACEMENTS)[number];

export function formatDevicePlacementLabel(placement?: string | null): string {
  switch (String(placement || '').toLowerCase()) {
    case 'in_suite':
      return 'In-suite';
    case 'common_area':
      return 'Common area';
    default:
      return 'Unspecified';
  }
}

export function formatDeviceTypeLabel(type?: string): string {
  if (!type) return 'Device';
  return type.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}
